import React from "react";
import { useHistory } from "react-router-dom";

// Icons
import IconChangeLanguage from "../../icons/IconChangeLanguage";

// Utils
import { LOCAL_STORAGE_LANGUAGE_CODE } from "../../constants/LocalStorage";

// Styles
import "./ChangeLanguage.scss";

const ChangeLanguage: React.FC = () => {
  const history = useHistory();

  const clickHandler = () => {
    localStorage.removeItem(LOCAL_STORAGE_LANGUAGE_CODE);
    history.push("/language");
  };

  return (
    <div className="change-language" onClick={clickHandler}>
      <p>
        Change Language <IconChangeLanguage />
      </p>
    </div>
  );
};

export default ChangeLanguage;
